import React from "react";

// relay. wordmark — dominant lowercase word + small square full-stop (punctuation scale).
export function RelayMark({ className = "", size = "text-sm" }) {
  return (
    <span className={`inline-flex items-baseline font-semibold lowercase tracking-tight ${size} ${className}`} data-testid="relay-mark">
      relay<span className="relay-dot" aria-hidden="true" />
    </span>
  );
}

// AVENIR / relay. product lockup. AVENIR stays small, uppercase, quiet and secondary;
// relay. is the dominant product wordmark. One consistent lockup across the product.
export function BrandLockup({ compact = false, className = "" }) {
  return (
    <div className={`flex flex-col leading-none ${className}`} data-testid="brand-lockup" aria-label="relay. by AVENIR">
      <span className="text-[9px] font-medium uppercase tracking-[0.32em] text-muted-foreground/80 mb-0.5">AVENIR</span>
      <RelayMark size={compact ? "text-lg" : "text-2xl"} className="text-primary" />
    </div>
  );
}
